'use client';

import { c as _c } from "react/compiler-runtime";
import { Divider } from '@mui/material';
import Grid, { type GridProps } from '@mui/material/Grid';
import type { PropsWithChildren } from 'react';
import AlternatePicks from './AlternatePick';
import ReviewComparisonTable from './ComparisonTable';
import { ReviewBodyProvider } from './Context';
import OutOfDateMessageBody from './OutOfDateMessage';
import { ProsAndCons } from './ProsAndCons';
import { RelatedLinks } from './RelatedLinks';
import ReviewBanner from './ReviewBanner';
import SidebarProductCard from './SidebarProductCard';
import ReviewSummary from './Summary';
import { TableOfContents } from './TableOfContents';
import BenefitsAndPerks from './WordpressSections/BenefitsAndPerks';
import DetailedReview from './WordpressSections/DetailedReview';
import DrawbacksAndConsiderations from './WordpressSections/DrawbacksAndConsiderations';
import HowToDecide from './WordpressSections/HowToDecide';
const LEFT_SPAN = 8;
const Container = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Grid container={true} {...props}>{props.children}</Grid>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
const LeftColumn = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      xs: 12,
      md: LEFT_SPAN
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Grid size={t1}><Grid container={true} gap={4}>{children}</Grid></Grid>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const RightColumn = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      xs: 12,
      md: 12 - LEFT_SPAN
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Grid size={t1}>{children}</Grid>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const ReviewBody = () => {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Container><LeftColumn><OutOfDateMessageBody /></LeftColumn></Container>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <RightColumn><TableOfContents /></RightColumn>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Container mb={4} direction="row-reverse">{t1}<LeftColumn><ReviewSummary /></LeftColumn></Container>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <RightColumn><SidebarProductCard /></RightColumn>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Container mb={4} direction="row-reverse">{t3}<LeftColumn><ProsAndCons /><DetailedReview /><ReviewComparisonTable /><ReviewBanner /><BenefitsAndPerks /><DrawbacksAndConsiderations /></LeftColumn></Container>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <HowToDecide />;
    t6 = <AlternatePicks />;
    t7 = <RelatedLinks />;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ReviewBodyProvider><Grid container={true}>{t0}{t2}{t4}<Container><LeftColumn>{t5}{t6}{t7}<Grid pt={6} pb={{
              xs: 2,
              md: 3
            }}><Divider /></Grid></LeftColumn></Container></Grid></ReviewBodyProvider>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
};
export default ReviewBody;